import Joi from "joi";

export const purchaseOrderTypeSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
});
